import React, {Component} from 'react'
import {
    Drawer, Table, Button, Space, Tag, Modal, Form, Select, Input, message, Popconfirm, Alert
} from 'antd'
import {
    getKpiRaterConfigList,
    saveKpiRaterConfig,
    toggleKpiRaterConfigStatus,
    getUserListForDropbox
} from '../../request'

const KPI_TYPE_CHANNEL_MONTHLY = 2

class KpiRaterConfigDrawer extends Component {
    formRef = React.createRef()
    state = {
        visible: false,
        loading: false,
        dataSource: [],
        userOptions: [],
        classInfo: {},
        editVisible: false,
        editRecord: null,
    }

    handleOpen = (classInfo) => {
        this.setState({visible: true, classInfo: classInfo || {}}, () => {
            this.loadList()
            this.loadUserOptions()
        })
    }

    handleClose = () => {
        this.setState({visible: false, dataSource: [], editVisible: false, editRecord: null})
    }

    loadList = () => {
        this.setState({loading: true})
        getKpiRaterConfigList({kpiType: KPI_TYPE_CHANNEL_MONTHLY}).then(res => {
            this.setState({loading: false, dataSource: res || []})
        }).catch(() => this.setState({loading: false}))
    }

    loadUserOptions = () => {
        getUserListForDropbox({type: 0}).then(res => {
            this.setState({userOptions: res || []})
        })
    }

    openEdit = (record) => {
        this.setState({editVisible: true, editRecord: record || null}, () => {
            if (this.formRef.current) {
                this.formRef.current.resetFields()
                if (record) {
                    this.formRef.current.setFieldsValue(record)
                }
            }
        })
    }

    closeEdit = () => {
        this.setState({editVisible: false, editRecord: null})
    }

    submitEdit = () => {
        this.formRef.current.validateFields().then(values => {
            const {editRecord} = this.state
            const param = {
                ...(editRecord || {}),
                ...values,
                kpiType: KPI_TYPE_CHANNEL_MONTHLY,
                status: values.status != null ? values.status : 1,
            }
            saveKpiRaterConfig(param).then(() => {
                message.success('保存成功')
                this.closeEdit()
                this.loadList()
            })
        })
    }

    toggleStatus = (record) => {
        const nextStatus = record.status === 1 ? 0 : 1
        toggleKpiRaterConfigStatus({id: record.id, status: nextStatus}).then(() => {
            message.success('操作成功')
            this.loadList()
        })
    }

    getColumns = () => {
        const {userOptions} = this.state
        const userName = (id) => {
            if (!id) return '-'
            const hit = userOptions.find(u => u.USER_ID === id)
            return hit ? hit.USER_NICK : id
        }
        return [
            {title: '员工', dataIndex: 'userId', render: (v) => userName(v)},
            {title: '主评分人', dataIndex: 'leaderId', render: (v) => userName(v)},
            {title: '第二评分人', dataIndex: 'secondRaterId', render: (v) => userName(v)},
            {
                title: '状态', dataIndex: 'status', width: 80,
                render: (v) => v === 1 ? <Tag color="cyan">启用</Tag> : <Tag color="red">停用</Tag>
            },
            {title: '备注', dataIndex: 'remark'},
            {
                title: '操作', key: 'actions', width: 180, fixed: 'right',
                render: (_, record) => (
                    <Space>
                        <Button type="link" size="small" onClick={() => this.openEdit(record)}>编辑</Button>
                        <Popconfirm title={record.status === 1 ? '确定停用？' : '确定启用？'}
                                    onConfirm={() => this.toggleStatus(record)}>
                            <Button type="link" size="small" danger={record.status === 1}>
                                {record.status === 1 ? '停用' : '启用'}
                            </Button>
                        </Popconfirm>
                    </Space>
                )
            }
        ]
    }

    render() {
        const {visible, loading, dataSource, userOptions, editVisible, editRecord, classInfo} = this.state
        return (
            <>
                <Drawer
                    title={`KPI评分人配置（渠道月度 kpiType=2）${classInfo?.name ? ' · 入口：' + classInfo.name : ''}`}
                    width={900}
                    open={visible}
                    onClose={this.handleClose}
                    destroyOnClose
                    extra={
                        <Space>
                            <Button type="primary" onClick={() => this.openEdit(null)}>新增评分人配置</Button>
                        </Space>
                    }
                >
                    <Alert
                        style={{marginBottom: 12}}
                        type="info"
                        showIcon
                        message="仅对 kpiType=2（渠道月度 KPI）生效。未在此配置的员工，默认仍使用钉钉花名册 Leader。"
                    />
                    <Table
                        bordered
                        size="small"
                        rowKey={r => r.id}
                        loading={loading}
                        columns={this.getColumns()}
                        dataSource={dataSource}
                        pagination={false}
                    />
                </Drawer>
                <Modal
                    title={editRecord ? '编辑评分人配置' : '新增评分人配置'}
                    open={editVisible}
                    onCancel={this.closeEdit}
                    onOk={this.submitEdit}
                    destroyOnClose
                    forceRender
                    zIndex={1050}
                >
                    <Form ref={this.formRef} labelCol={{span: 6}} wrapperCol={{span: 16}}
                          initialValues={{status: 1}}>
                        <Form.Item name="userId" label="员工" rules={[{required: true, message: '请选择员工'}]}>
                            <Select
                                showSearch
                                allowClear
                                placeholder="请选择员工"
                                optionFilterProp="children"
                                fieldNames={{label: 'USER_NICK', value: 'USER_ID'}}
                                filterOption={(input, option) => {
                                    const searchText = (option?.USER_NICK ?? '') + (option?.pinyin ?? '')
                                    return searchText.toLowerCase().includes(input.toLowerCase())
                                }}
                                options={userOptions}
                                disabled={!!editRecord}
                            />
                        </Form.Item>
                        <Form.Item name="leaderId" label="主评分人" rules={[{required: true, message: '请选择主评分人'}]}>
                            <Select
                                showSearch allowClear placeholder="请选择主评分人"
                                optionFilterProp="children"
                                fieldNames={{label: 'USER_NICK', value: 'USER_ID'}}
                                filterOption={(input, option) => {
                                    const searchText = (option?.USER_NICK ?? '') + (option?.pinyin ?? '')
                                    return searchText.toLowerCase().includes(input.toLowerCase())
                                }}
                                options={userOptions}
                            />
                        </Form.Item>
                        <Form.Item name="secondRaterId" label="第二评分人">
                            <Select
                                showSearch allowClear placeholder="可选,不配置则无第二评分人"
                                optionFilterProp="children"
                                fieldNames={{label: 'USER_NICK', value: 'USER_ID'}}
                                filterOption={(input, option) => {
                                    const searchText = (option?.USER_NICK ?? '') + (option?.pinyin ?? '')
                                    return searchText.toLowerCase().includes(input.toLowerCase())
                                }}
                                options={userOptions}
                            />
                        </Form.Item>
                        <Form.Item name="status" label="状态" rules={[{required: true}]}>
                            <Select options={[
                                {label: '启用', value: 1},
                                {label: '停用', value: 0},
                            ]}/>
                        </Form.Item>
                        <Form.Item name="remark" label="备注">
                            <Input.TextArea rows={2} maxLength={200} showCount/>
                        </Form.Item>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default KpiRaterConfigDrawer
